import { BaseModel } from "../base-model";

export interface IUpdateModel {
  Field?: string;
  Value?: any;
}

export class UpdateModel extends BaseModel<IUpdateModel> {
  Field?: string;
  Value?: any;
  constructor(option?: IUpdateModel) {
    super(option);
  }
}
